import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import DetailWrapper from '../../../sharedcomponents/4layouts/DetailWrapper'
import useDetailEditMode from '../../../sharedcomponents/4layouts/useDetailEditMode'
import LeftCard from '../../../sharedcomponents/5templates/detailCards/leftCard'
import ListBucketCard from '../../../sharedcomponents/5templates/detailCards/listBucketCard'
import useAccount from './useAccount'
import LeftChild from './LeftChild'

const AccountDetail = ({ createMode }) => {
  const { accountId, type } = useParams()

  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode)

  const {
    bulkUpdateContractsCallBack,
    useGetOneFatContractQuery,
    fetchAuxiliaryRecords,
    makeInMemoryContractRecord,
    finalAuxiliaryRecords,
    contractTypes,
    removeAccount,
    suspendAccount,
    typeIdToDisplayName,
    upsertContractCallback,
    loading: updateAccountsLoading
  } = useAccount()

  const {
    data: { data: rawAccountRecord } = {
      data: {}
    },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneFatContractQuery(
    {
      include: ['counts'],
      id: accountId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  )
  const primaryAccountRecord = createMode
    ? makeInMemoryContractRecord(type)
    : JSON.parse(JSON.stringify(rawAccountRecord))
  primaryAccountRecord.refetch = refetch

  const loading = useMemo(() => updateAccountsLoading || isLoading, [updateAccountsLoading, isLoading])

  return (
    <DetailWrapper
      entityDisplayName={'Account'}
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      typeIdToDisplayName={typeIdToDisplayName}
      primaryDetailRecord={primaryAccountRecord}
      isLoading={!createMode && (loading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertContractCallback}
      bulkUpdateCallBack={bulkUpdateContractsCallBack}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
    >
      {({ formikProps, activationChangeCallback, deleteEntityCallback }) => {
        return (
          <>
            <div style={{ float: 'left', width: '34%' }}>
              <LeftCard
                entityDisplayName={'Account'}
                formikProps={formikProps}
                editMode={detailEditMode}
                typeIdToDisplayName={typeIdToDisplayName}
                deleteEntityCallback={deleteEntityCallback(removeAccount)}
                activationChangeCallback={activationChangeCallback(suspendAccount)}
                listOfTypes={contractTypes}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
              >
                <LeftChild
                  formikProps={formikProps}
                  editMode={detailEditMode}
                  createMode={createMode}
                />
              </LeftCard>
            </div>
            <div style={{ float: 'left', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
              />
            </div>
            <div style={{ float: 'right', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.tercero}
              />
            </div>
          </>
        )
      }}
    </DetailWrapper>
  )
}
export default AccountDetail
